import axios from "axios";
import Decimal from "decimal.js";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { SecurityId, } from "../../Types";
import ValidationError from "../../ZodError";
import { FinMasonError, FinMasonErrorResponse } from "../types";
export const portfolioPlanClassificationByIdURL = (portfolioPlanId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${portfolioPlanId}/classification`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${portfolioPlanId}/classification`;
const ClassName = z.string().brand("ClassName");
const CategoryName = z.string().brand("CategoryName");
const Security = z.object({
    securityId: SecurityId,
    weight: z.string().transform((x) => new Decimal(x)),
    class: ClassName.optional(),
    simpleCategory: CategoryName.optional(),
    category: z.string().optional(),
    categoryType: z.string().optional(),
});
const Category = z.object({
    weight: z.string().transform((x) => new Decimal(x)),
    securities: z.array(Security),
});
const Classification = z.object({
    weight: z.string().transform((x) => new Decimal(x)),
    categories: z.record(z.string(), Category),
});
const PortfolioPlanClassification = z.object({
    data: z.record(z.string(), Classification),
});
export const getPortfolioPlanClassificationById = async (portfolioPlanId, config) => {
    const { data, status } = await axios.get(portfolioPlanClassificationByIdURL(portfolioPlanId), {
        headers: {
            version: "20240910",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
        validateStatus: () => true,
    });
    if (status === 550) {
        const parsed = FinMasonErrorResponse.parse(data);
        if (parsed.details.statusCode === "FIN_MASON_UNKNOWN_ASSET") {
            return new FinMasonError(parsed.message, parsed.details.invalidPositions);
        }
        throw new Error("Unexpected FinMason error");
    }
    if (status >= 300) {
        const errorMessage = `[${getPortfolioPlanClassificationById.name}] received status code ${status}`;
        errorLog(errorMessage, data);
        throw new Error(errorMessage);
    }
    const decoded = PortfolioPlanClassification.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    const errorMessage = `[getPortfolioPlanClassificationById.ts] received unexpected data`;
    errorLog(errorMessage, decoded.error.message);
    throw new ValidationError(errorMessage, decoded.error.issues);
};
//# sourceMappingURL=getPortfolioPlanClassificationById.js.map